import React, {Component} from "react";
import fetch from "isomorphic-unfetch";
import {csrfToken} from "../../../utils"
import Select from "react-select";
import swal from "sweetalert2";
import ReactTable from "react-table";
import ReactTableFullScreen from "../../../ReactTableFullScreen";

export default class NoProposals extends Component {

    constructor(props) {
        super(props);
    }

    render() {
        var data = this.props.payers;
        var seasons = this.props.seasons;
        var currentSeason = this.props.currentSeason;

        const columns = [
            {
                id: "season",
                Header: "Saison",
                width: 200,
                sortable: false,
                filterable: !this.props.nofilter,
                accessor: d => d.season_label,
                Cell: props => (
                    <div style={{textAlign:"center"}}>{props.value.replace("Saison ", "")}</div>
                ),
                Filter: ({ filter, onChange }) => (
                    <select
                        onChange={event => onChange(event.target.value)}
                        style={{ width: "100%" }}
                        value={filter ? filter.value : currentSeason.label}
                    >
                        {seasons.map(function (element) {
                            return <option value={element.label} key={"saison"+element.id}>{element.label}</option>
                        })
                        }
                    </select>
                ),
            },
            {
                id: "payer_lastname",
                Header: "Nom",
                width: 350,
                accessor: d => d.payer_lastname,
                Cell: props => {
                    return(
                        <a href={`/payments/summary/${props.original.payer_id}`} className="w-100 d-flex font-underlined">
                            {props.original.payer_lastname.toUpperCase()}
                        </a>
                    )
                }
            },
            {
                id: "payer_firstname",
                Header: "Prénom",
                width: 350,
                accessor: d => d.payer_firstname,
                Cell: props => {
                    return(
                        <a href={`/payments/summary/${props.original.payer_id}`} className="w-100 d-flex font-underlined">
                            {props.original.payer_firstname}
                        </a>
                    )
                },
            }
        ]

        return (
            <div className="ibox">
            <ReactTable
                resizable={false}
                previousText="Précédent"
                nextText="Suivant"
                loadingText="Chargement..."
                noDataText="Aucune donnée"
                pageText="Page"
                ofText="sur"
                rowsText="résultats"
                minRows={1}
                columns={columns}
                data={data}
                defaultSorted={[{id: "payer_lastname", asc: true}]}
                filterable
                defaultFiltered={[{ id: "season", value: this.props.currentSeason.label }]}
                defaultFilterMethod={(filter, row) => {
                    if (row[filter.id] != null) {
                        return row[filter.id]
                            .toLowerCase()
                            .includes(filter.value.toLowerCase())
                    }
                }}
            />
            </div>
        )

    }

}